import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAccountUserAssigning = createAsyncThunk(
  "GetAccountUserAssigning",
  async ( flow, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/UserWorkFlow/GetAccountUserAssigning",
        {
          flowGUID: flow.flowGUID,
          canMainTaskFlow: flow.canMainTaskFlow,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetAccountUserAssigning");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AccountUserAssigning = createSlice({
  name: "AccountUserAssigning",
  initialState: {
    AccountUserAssigning: {},
    loadingAccountUserAssigning: false,
    errorAccountUserAssigning: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAccountUserAssigning.pending, (state, action) => {
        state.loadingAccountUserAssigning = true;
        state.AccountUserAssigning = action.payload;
        state.errorAccountUserAssigning = null;
      })
      .addCase(GetAccountUserAssigning.fulfilled, (state, action) => {
        state.loadingAccountUserAssigning = false;
        state.AccountUserAssigning = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAccountUserAssigning.rejected, (state, action) => {
        state.loadingAccountUserAssigning = false;
        state.errorAccountUserAssigning = action.payload;
      });
  },
});

export default AccountUserAssigning.reducer;
